/**
 * Defaults
 */
import ComponentManager from "./scripts/ComponentManager";
import Header from "../src/Components/Header/Header";
import Footer from "../src/Components/Footer/Footer";
import CookiesBar from "../src/Components/CookiesBar/CookiesBar";
import Flexible from "../src/Layout/Flexible/Flexible";
import "../src/Components/IntersectionObserver/IntersectionObserver"
import "../src/Components/HoverFlipTile/HoverFlipTile"

/*
 * animations:
 * import {WOW} from '../node_modules/wowjs';
 * new WOW({ live: false }).init();
 */

/**
 * Bootstrap components
 */
//import Alert from '../node_modules/bootstrap/js/src/alert'
//import Button from '../node_modules/bootstrap/js/src/button'
import { Collapse } from "bootstrap";
import { Dropdown } from "bootstrap";
import { Modal } from "bootstrap";
//import Popover from '../node_modules/bootstrap/js/src/popover'
//import ScrollSpy from '../node_modules/bootstrap/js/src/scrollspy'
//import Tab from '../node_modules/bootstrap/js/src/tab'
//import Toast from '../node_modules/bootstrap/js/src/toast'
//import Tooltip from '../node_modules/bootstrap/js/src/tooltip'

export {
  //Alert,
  //Button,
  Collapse,
  Dropdown,
  Modal,
  //Popover,
  //ScrollSpy,
  //Tab,
  //Toast,
  //Tooltip
};
